module.exports = __webpack_public_path__ + "static/img/Waste management-01.ff62f837.jpg";